Ext.define('SA.view.pvt.ExportButton', {
    alias: 'widget.pvt-export-button',
    extend: 'SA.view.Button',

    autoEl: {tabindex: 0},
    cls: 'sa-pvt-export-button',
    emitActivate: true,
    icon: 'sa-icon-export',
    text: 'Export',
    width: 85,

    onClick() {
        if (this.emitActivate && !this.isActive()) {
            this.setActive();
            this.fireEvent('activate');
            return;
        }

        this.callParent();
    }
});
